import { create } from 'zustand';

export type ToastIntent = 'info' | 'warning' | 'success' | 'danger';

export interface Toast {
  id: string;
  title: string;
  description?: string;
  intent?: ToastIntent;
  targetSessionId?: string;
  createdAt: number;
}

interface NotificationStore {
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id' | 'createdAt'> & Partial<Pick<Toast, 'createdAt'>>) => string;
  dismissToast: (id: string) => void;
  clear: () => void;
}

export const useNotificationStore = create<NotificationStore>((set) => ({
  toasts: [],

  addToast: (toast) => {
    const id = toast.title + '-' + Date.now().toString(36);
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id,
          createdAt: toast.createdAt ?? Date.now(),
          intent: toast.intent ?? 'info',
          ...toast,
        },
      ],
    }));
    return id;
  },

  dismissToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },

  clear: () => set({ toasts: [] }),
}));
